import { render } from "./DocumentTopBarButtons.vue?vue&type=template&id=3767df42&scoped=true"
import script from "./DocumentTopBarButtons.vue?vue&type=script&lang=js"
export * from "./DocumentTopBarButtons.vue?vue&type=script&lang=js"

import "../../assets/scss/document_top_bar.scss?vue&type=style&index=0&id=3767df42&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3767df42"]])

export default __exports__